import companyCodes from '../data/companyCodes.json'

export default (id) => companyCodes[id]